export enum AutoOrderProduct {
  AutoBuy = 'AB',
  AutoSell = 'AS',
}

export enum AutoSellType {
  TakeProfit = 'TP',
  StopLoss = 'SL',
}
